import { render, staticRenderFns } from "./InstallAndroidApp.vue?vue&type=template&id=2a18a970&scoped=true"
import script from "./InstallAndroidApp.vue?vue&type=script&lang=js"
export * from "./InstallAndroidApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a18a970",
  null
  
)

export default component.exports